export const GET_GIFT_LINK_REQUEST = 'GET_GIFT_LINK_REQUEST';
export const GET_GIFT_LINK_SUCCESS = 'GET_GIFT_LINK_SUCCESS';
export const GET_GIFT_LINK_FAILURE = 'GET_GIFT_LINK_FAILURE';

export const SET_PUBLISHED_EMBED_SOURCE = 'SET_PUBLISHED_EMBED_SOURCE';

export const SET_OFFER_SOURCE = 'SET_OFFER_SOURCE';
